export const environment = {
    production: false,
    faviconPath: "assets/ng/assets/img/favicon-test.svg",
};
